export default __webpack_public_path__ + "static/media/g4.0d20d2c1.jpg";